import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Button, Card, Container, Grid, IconButton, Stack, Tab, Typography, useMediaQuery } from '@mui/material';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import TablePermissionControlGroup from 'src/component-project/PermissionControlPages/TablePermissionControlGroup';
import Breadcrumb from 'src/components/Breadcrumb/Breadcrumb';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Iconify from 'src/components/iconify';
import CreateGroupModal from 'src/components/modal/CreateGroupModal';
import Scrollbar from 'src/components/scrollbar/Scrollbar';
import { sendRequest, serviceList } from 'src/utils';
import Loader from 'src/components/loader/loader';
import ManagerGroupPermission from 'src/component-project/PermissionControlPages/ManagerGroupPermission';
import TablePermissionUser from 'src/component-project/PermissionControlPages/TablePermissionUser';

const PermissionsManagement = () => {
    const { t } = useTranslation();
    const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const params = useParams();

    const [tableDataPermissions, setTableDataPermissions] = useState([]);
    const [getFlagsPermissions, setGetFlagsPermissions] = useState(false);
    const getRefPermissions = useRef(false);

    const [value, setValue] = useState('1');
    const [loading, setLoading] = useState(false);

    const [selectedItem, setSelectedItem] = useState({});
    const groupId = useRef(0);
    const groupData = useRef({});

    const [tableDataGroupPermissions, setTableDataGroupPermissions] = useState([]);
    const [getFlagsGroupPermissions, setGetFlagsGroupPermissions] = useState(false);
    const getRefGroupPermissions = useRef(false);

    const [activeTable, setActiveTable] = useState(false);

    const handleChange = (event, newValue) => {
        setValue(newValue);
        if (newValue === '2') {
            setActiveTable(true);
        }
    };

    const handleCheckboxChange = (data) => {
        setSelectedItem(data);
        const userType = data.user_type;
        groupId.current = data.id;
        groupData.current = data;
        setLoading(true);
        setTimeout(() => {
            getDataPermissions(userType);
        }, 500);
        setValue('1');
    };

    const getDataPermissions = (valueUser) => {
        if (getRefPermissions.current) {
            return;
        }
        getRefPermissions.current = true;
        const Inval = [valueUser, '', 99999999];
        sendRequest(
            serviceList.getListScreenGroup,
            Inval,
            getDataResultPermissions,
            true,
            timeOutFunctPermissions,
            40000
        );
    };

    const getDataResultPermissions = (reqInfoMap, message) => {
        getRefPermissions.current = false;
        setGetFlagsPermissions(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableDataPermissions(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunctPermissions = (reqInfo) => {
        getRefPermissions.current = false;
        setGetFlagsPermissions(false);
        toast.error(t('error.time_out'));
    };

    useEffect(() => {
        if (tableDataPermissions) {
            setTimeout(() => {
                getDataGroupPermissions(groupId.current);
            }, 700);
        }
    }, [groupId, tableDataPermissions]);

    const getDataGroupPermissions = (groupId) => {
        if (getRefGroupPermissions.current) {
            return;
        }
        getRefGroupPermissions.current = true;
        setGetFlagsGroupPermissions(true);
        const Inval = [groupId];
        sendRequest(
            serviceList.getGroupPermission,
            Inval,
            getDataResultGroupPermissions,
            true,
            timeOutFunctGroupPermissions,
            40000
        );
    };

    const getDataResultGroupPermissions = (reqInfoMap, message) => {
        getRefGroupPermissions.current = false;
        setGetFlagsGroupPermissions(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            const data = message.proc_data.rows;
            // console.log('DataResultGroupPermissions',data)
            // const mergedArray = tableDataPermissions.map((item1) => {
            //     const matchingItem = data.find((item2) => (item2.screen_group_id === item1.id))
            //     console.log("matching item", matchingItem)
            //     if (matchingItem) {
            //         return {
            //             ...item1,
            //             group_id: matchingItem.group_id,
            //             search: matchingItem.search,
            //             insert: matchingItem.insert,
            //             update: matchingItem.update,
            //             delete: matchingItem.delete,
            //             block: matchingItem.block,
            //             import: matchingItem.import,
            //             export: matchingItem.export,
            //         }
            //     }
            //     return item1;
            // });
            // console.log('DataResultGroupPermissions', tableDataPermissions, data, mergedArray)
            setTableDataGroupPermissions(data);
        }
        setLoading(false);
    };

    const timeOutFunctGroupPermissions = (reqInfo) => {
        getRefGroupPermissions.current = false;
        setGetFlagsGroupPermissions(false);
        toast.error(t('error.time_out'));
        setLoading(false);
    };

    // console.log('groupid', groupData.current)

    return (
        <>
            <Helmet>
                <title> {t('phan_quyen_nguoi_dung')} </title>
            </Helmet>

            <Container>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
                    <Typography variant="h4" gutterBottom>
                        {t('phan_quyen_nguoi_dung')}
                    </Typography>
                    <Button
                        variant="contained"
                        startIcon={<Iconify icon="ri:device-line" />}
                        component={RouterLink}
                        to={`/home/manager-screens/${params.idPermission}`}
                    >
                        {t('quan_ly_man_hinh')}
                    </Button>
                </Stack>
                <Breadcrumb paths={[{ label: t('phan_quyen_nguoi_dung'), url: '#', navigate: false }]} />
                <Loader loading={loading} />
                <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap={'wrap'}>
                    <Card
                        maxWidth={isSmallScreen ? '100%' : '50%'}
                        sx={{ width: isSmallScreen ? '100%' : '22%', height: '650px' }}
                    >
                        <ManagerGroupPermission selectedItem={selectedItem} fuctHandleChange={handleCheckboxChange} />
                    </Card>
                    <Card
                        maxWidth={isSmallScreen ? '100%' : '50%'}
                        sx={{ width: isSmallScreen ? '100%' : '77%', height: '650px', maxHeight: '700px' }}
                    >
                        <Box sx={{ width: '100%', typography: 'body1' }}>
                            <TabContext value={value}>
                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                    <TabList
                                        onChange={handleChange}
                                        aria-label="lab API tabs example"
                                        variant="fullWidth"
                                    >
                                        <Tab
                                            label={
                                                groupData.current?.user_type !== '1'
                                                    ? t('permissions_group_')
                                                    : t('permissions_admin')
                                            }
                                            value="1"
                                        />
                                        {groupData.current?.user_type !== '1' && (
                                            <Tab label={t('permissions_user')} value="2" />
                                        )}
                                    </TabList>
                                </Box>
                                <TabPanel value="1">
                                    <TablePermissionControlGroup
                                        tableData={tableDataGroupPermissions}
                                        fuctGet={getDataGroupPermissions}
                                        valueGroupId={groupId.current}
                                    />
                                </TabPanel>
                                <TabPanel value="2">
                                    <TablePermissionUser valueGroupId={groupId.current} activeTable={activeTable} />
                                </TabPanel>
                            </TabContext>
                        </Box>
                    </Card>
                </Stack>
            </Container>
        </>
    );
};

export default PermissionsManagement;
